import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Listbox } from "@headlessui/react";
import TabsMobile from "../__template/TabsMobileComponent";
import { useTranslation } from "react-i18next";
import { StatsInvoice } from "../common/home/Stats";
import { BackButton } from "../common/BackButton";

const AccountWeb = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const [lastPage, setLastPage] = useState(0);
  const { t } = useTranslation();

  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataNews, setdataNews] = useState<any>([]);
  let [isOpen, setIsOpen] = useState(true);
  let [loading, setLoading] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getData();
    }
  }, []);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck().then((resCredential) => {
        dispatch(setUser(resCredential.data.user));
        getData();
      });
    }
  }, [location.pathname.split("/")[2]]);

  function getData() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")));
    temp = temp.accounts[0].callerIdentities;
    console.log(temp);
    setData(temp);
  }

  function getImgContent(url: string) {
    return env + "main_base/image/get/" + url + "/pas";
  }

  const changeSize = () => {};

  const changePage = () => {};

  return (
    <>
      <div className="font-montserrat">
        <StatsInvoice />
        <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full">
          <div className="flex p-4">
            <BackButton />
            <div className="font-bold text-4xl">{t("ACCOUNT.title")}</div>
          </div>
          <div className="w-full rounded-xl">
            {data.map((item: any) => {
              return (
                <div className="flex flex-row shadow-xl rounded-2xl mb-4 mt-4">
                  <div className="">
                    {item.photoUrl && (
                      <img
                        src={getImgContent(item.photoUrl)}
                        alt=""
                        className="w-[7vh] h-[7vh] mx-3 my-3 rounded-full"
                      />
                    )}
                    {!item.photoUrl && (
                      <img
                        src={getImgContent("aa")}
                        alt=""
                        className="w-[7vh] h-[7vh] mx-3 my-3 rounded-full"
                      />
                    )}
                  </div>
                  <div className={`flex flex-col rounded-r-2xl px-3 justify-center  ${item.active ? 'bg-white' : 'bg-gray-300'} w-full`}>
                    <div className={`font-montserrat m-0 font-bold text-sm ${item.active ?'text-black':'text-gray-500'}`}>
                      {item.name}
                    </div>
                    <div className={`font-montserrat m-0 text-xs font-normal ${item.active ?'text-black':'text-gray-500'}`}>
                      {item.title}: {item.callerId}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default AccountWeb;
